module.exports = __webpack_public_path__ + "img/7-1.94888e7c.jpg";